var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.onFileBtnClick}},[_c('input',{ref:"fileInput",staticClass:"d-none",attrs:{"type":"file"},on:{"input":_vm.onInput}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }